import React, { useEffect, useState } from 'react';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { ProjectCrystalDTO } from 'business/models/Models';
import CrystalInfoDetailPanel from './CrystalInfoDetailPanel';
import RMSelect from 'components/customComponents/Controls/RMSelect';
import { IStyle } from 'Styles';
import SwitchButton from 'components/Button/SwitchButton/switchButton';

export interface CrystalInfoPanelProps {
  crystalDTO: ProjectCrystalDTO[];
}

const optionsComboDetail = [
  {
    name: 'Experiment Name',
    id: 1,
    value: 'experimentName',
  },
  {
    name: 'Crystal Name',
    id: 2,
    value: 'name',
  },
  {
    name: 'Protein Name',
    id: 3,
    value: 'proteinName',
  },
  {
    name: 'Resolution',
    id: 4,
    value: 'resolution',
  },
  {
    name: 'Structure',
    id: 5,
    value: 'structure',
  },
  {
    name: 'Date Frozen',
    id: 6,
    value: 'dateFrozen',
  },
  {
    name: 'Data Collected',
    id: 7,
    value: 'dataCollected',
  },
  {
    name: 'Soaking',
    id: 8,
    value: 'soaking',
  },
];
const compareValues = (key?, order = 'asc') => {
  return (firstObject, secondObject) => {
    if (!key || !firstObject.hasOwnProperty(key) || !secondObject.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const valueFirstObject =
      typeof firstObject[key] === 'string'
        ? firstObject[key].toUpperCase()
        : firstObject[key];
    const valueSecondObject =
      typeof secondObject[key] === 'string'
        ? secondObject[key].toUpperCase()
        : secondObject[key];

    let comparison = 0;
    if (valueFirstObject > valueSecondObject) {
      comparison = 1;
    } else if (valueFirstObject < valueSecondObject) {
      comparison = -1;
    }
    return order === 'desc' ? comparison * -1 : comparison;
  };
};

const CrystalInfoPanel = (props: CrystalInfoPanelProps) => {
  const { crystalDTO } = props;
  const [combo, setCombo] = useState(optionsComboDetail.slice(0, 3));
  const [selectedOption, setSelectedOptionState] = useState(optionsComboDetail[0].id);
  const [crystalState, setCrystalState] = useState(crystalDTO.sort(compareValues()));
  const [isShowCrystalDetail, setIsShowCrystalDetail] = useState(false);

  useEffect(() => {
    const arr = [...crystalDTO];
    arr.sort(
      compareValues(optionsComboDetail.find((x) => x.id === +selectedOption).value),
    );
    setCrystalState(arr);
  }, [crystalDTO, selectedOption]);

  useEffect(() => {
    isShowCrystalDetail
      ? setCombo(optionsComboDetail)
      : setCombo(optionsComboDetail.slice(0, 3));
  }, [isShowCrystalDetail]);

  const onChangeOptions = (event) => {
    setSelectedOptionState(event.target.value);
  };

  const getCrystalInfo = () => {
    const content = [];
    {
      crystalState.map((crystal) =>
        content.push(
          <div id={`crystalinfopanel-crystalinfo-${crystal.name}-wrapper`} style={styles.crystalInfoDiv}>
            <div id={`crystalinfopanel-crystalinfo-${crystal.name}-mainrow`} className="row">
              <div id={`crystalinfopanel-crystalinfo-${crystal.name}-iconcol`} className="col-1" style={{ paddingInline: '8%' }}>
                <RMSvgIcon
                  id={`crystalinfopanel-crystalinfo-${crystal.name}-icon`}
                  name={crystal.dataCollected ? 'CrystalsGrey' : 'Crystals'}
                  fill="none"
                  width={40}
                  height={40}
                />
              </div>
              <div id={`crystalinfopanel-crystalinfo-${crystal.name}-textcol`} className="col-6" style={{ paddingInline: '10%' }}>
                <div id={`crystalinfopanel-crystalinfo-${crystal.name}-title`}>{crystal.name}</div>
                <div id={`crystalinfopanel-crystalinfo-${crystal.experimentName}-experiment`} style={{ color: '#808080' }}>{crystal.experimentName}</div>
                <div id={`crystalinfopanel-crystalinfo-${crystal.name}-protein`} style={{ color: '#808080' }}>{crystal.proteinName}</div>
              </div>
            </div>

            <div
              id={`crystalinfopanel-crystalinfo-${crystal.name}-detailrow`}
              className="row"
              style={styles.crystalDetail}
              hidden={!isShowCrystalDetail}
            >
              <div id={`crystalinfopanel-crystalinfo-${crystal.name}-infocol`} className="col-1" style={{ paddingInline: '4%' }}>
                <RMSvgIcon id={`crystalinfopanel-crystalinfo-${crystal.name}-infoicon`} name="Info" fill="#808080" width={25} height={25} />
              </div>
              <div id={`crystalinfopanel-crystalinfo-${crystal.name}-detailcol`} className="col-11" style={{ paddingInline: '14%' }}>
                <CrystalInfoDetailPanel crystalDetail={crystal} />
              </div>
            </div>
          </div>,
        ),
      );
    }
    return content;
  };

  const getCrystalHeader = () => {
    return (
      <>
        <div id='crystalinfopanel-crystalheader-wrapper' style={{ flex: '85%' }} className="nodeInfo nodeLabel row">
          <div id="crystalinfopanel-crystalheader-title" className="col-6">Crystal Information</div>
          <div id="crystalinfopanel-crystalheader-count" className="col-5" style={{ textAlign: 'right' }}>
            {crystalState.length}
          </div>
        </div>
        <div id={`crystalinfopanel-crystalheader-${styles.crystalheader}-controls`} className="row" style={styles.crystalHeader}>
          <div id="crystalinfopanel-crystalheader-sort-label" className="nodeInfo">Sort By</div>
          <div id="crystalinfopanel-crystalheader-sort-controls" style={{ paddingInline: '2%' }}>
            <RMSelect
              options={combo}
              selectedValue={selectedOption}
              className="padding5"
              onChange={onChangeOptions}
              placeholder={'Sort By'}
              style={styles.combo}
            />
            <RMSvgIcon
              id="crystalinfopanel-crystalheader-sort-icon"
              name="OrderBy"
              width={30}
              height={30}
              style={{ paddingInline: '1%' }}
            />
          </div>

          <label id="crystalinfopanel-crystalheader-showdetails-label" >Show Details</label>
          <SwitchButton
            customStyle={styles.switchStyle}
            isToggled={isShowCrystalDetail}
            onToggle={() => setIsShowCrystalDetail(!isShowCrystalDetail)}
          />
        </div>
      </>
    );
  };
  return (
    <div id={`crystalinfopanel-${styles.crystalheader}`} style={{ paddingBlock: '10px', height: '70%', paddingInline: '2%' }}>
      {getCrystalHeader()}
      <div id={`crystalinfopanel-${styles.crystalinfo}`} style={{ overflowY: 'auto', overflowX: 'hidden', height: '92%' }}>
        {getCrystalInfo()}
      </div>
    </div>
  );
};

const styles: IStyle = {
  combo: {
    width: 'auto',
    height: 'auto',
    flexDirection: 'column',
  },
  crystalDetail: {
    marginInline: 'inherit',
    borderRadius: 'inherit',
    backgroundColor: '#E0E0E0',
    paddingTop: '1%',
    paddingBottom: '1%',
  },
  switchStyle: {
    paddingInline: '1%',
    marginLeft: '1%',
  },
  crystalInfoDiv: {
    outline: '2px solid #CCC',
    border: '1px solid #999',
    borderRadius: '5px',
    paddingTop: '2%',
    margin: '1rem',
    paddingBottom: '1%',
  },
  crystalHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '2%',
    paddingInline: '6%',
  },
};
export default CrystalInfoPanel;
